import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en-GB';
import { currentLocale } from '@screenleads/i18n';
registerLocaleData(localeEs);
registerLocaleData(localeEn);
export const customDateProviders = [{ provide: LOCALE_ID, useFactory: currentLocale }];
